export default "__VITE_ASSET__BN1AY0Ud__"